/**
 * 🛡️ GOLDEN SETTINGS STORAGE (Zenith v1.0)
 * 
 * Centralized manager for all browser persistence.
 * Prevents key collision and enables atomic memory purges.
 */

const PREFIX = 'agendacrm';

export const STORAGE_KEYS = {
    // Auth & Session
    SESSION: `${PREFIX}_session`,
    TOKEN: `${PREFIX}_token`,
    USER: `${PREFIX}_user`,
    USER_ID: `${PREFIX}_user_id`,
    TENANT_SIM: `${PREFIX}_simulated_tenant`,
    IMPERSONATION: `${PREFIX}_impersonation_original`,
    CURRENT_TENANT: `${PREFIX}_current_tenant_id`,
    LAST_VERTICAL: `${PREFIX}_last_vertical_metadata`,

    // UI & Preferences
    THEME_CONFIG: `${PREFIX}_theme_config`,
    LANGUAGE: `${PREFIX}_language`,
    CURRENCY: `${PREFIX}_currency`,
    DARK_MODE: `${PREFIX}_dark_mode`,

    // Features & Plans
    FEATURES: `${PREFIX}_features`,
    REFERRAL_CODE: `${PREFIX}_referral_code`,
    REFERRAL_TS: `${PREFIX}_referral_timestamp`,

    // Push Notifications & Devices
    PUSH_TOKEN: `${PREFIX}_push_token`,
    PUSH_PLATFORM: `${PREFIX}_push_platform`,
    DEVICE_ID: `${PREFIX}_device_id`,

    // Hardware (POS peripherals)
    HARDWARE_CONFIG: `${PREFIX}_hardware_config`,

    // Supabase Session
    SB_ACCESS_TOKEN: `${PREFIX}_sb_access_token`,
    SB_REFRESH_TOKEN: `${PREFIX}_sb_refresh_token`,

    // Medical Engines
    DENTAL_IMAGES: `${PREFIX}_dental_images`,

    // Portal
    PORTAL_EVENTS: `${PREFIX}_portal_events`
};

export const settingsStorage = {
    getItem<T>(key: keyof typeof STORAGE_KEYS): T | null {
        const val = localStorage.getItem(STORAGE_KEYS[key]);
        if (!val) return null;
        try {
            return JSON.parse(val) as T;
        } catch {
            return val as unknown as T;
        }
    },

    setItem(key: keyof typeof STORAGE_KEYS, value: unknown): void {
        const strValue = typeof value === 'string' ? value : JSON.stringify(value);
        localStorage.setItem(STORAGE_KEYS[key], strValue);
    },

    removeItem(key: keyof typeof STORAGE_KEYS): void {
        localStorage.removeItem(STORAGE_KEYS[key]);
    },

    /**
     * 🧼 PURGE SENSITIVE DATA
     * Removes all session and tenant related data while keeping 
     * preferences like theme or language if desired.
     */
    purgeSensitiveData(): void {
        console.log("🧼 [Zenith] Purging all sensitive localStorage data...");
        const sensitiveKeys: (keyof typeof STORAGE_KEYS)[] = [
            'SESSION', 'TOKEN', 'USER', 'TENANT_SIM', 'IMPERSONATION', 'LAST_VERTICAL'
        ];
        sensitiveKeys.forEach(k => this.removeItem(k));
    },

    /**
     * Nuke everything (Factory Reset)
     */
    clearAll(): void {
        localStorage.clear();
    }
};


